const s = (t = "", n = 2) => {
  if (t === null || typeof t != "string" || !t.trim())
    return t;
  const r = (t ?? "").toLocaleUpperCase().split(" ").filter((e) => e.trim());
  return r.length > 1 ? r.splice(0, n).reduce((e, i) => e + i[0], "") : r[0].slice(0, n);
};
export {
  s as getInitials
};
